// extracted by css-extract-rspack-plugin
export default {"list":"list-iMFbKg","entry":"entry-qazZI_","label":"label-E4wsNA","valueRow":"valueRow-ZcQvOa","value":"value-K5FqKT","action":"action-mzMecX"};